import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonJourneysRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/journeys` — the address the embedded app's profile tab bar links to.
 * It forwards to the tab's own URL once the rollout flag is on, and renders the embedded app in
 * place while it is off. A journey's own page beneath it forwards the same way.
 */
function JourneysPersonJourneysIndexRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonJourneysRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/$personId/journeys/')({
  component: JourneysPersonJourneysIndexRoute,
});
